import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tir-pm-comment-chat-quote-message__message" }
const _hoisted_2 = { class: "tir-pm-comment-chat-quote-message__inner-user-foto" }
const _hoisted_3 = { class: "tir-pm-comment-chat-quote-message__author-info" }
const _hoisted_4 = { class: "tir-pm-comment-chat-quote-message__message-text" }
const _hoisted_5 = { class: "tir-pm-comment-chat-quote-message__right-area" }

import {
  IFilePreview,
  TirPmIconView,
  TirPmFilePreview,
  FilePreviewVariantEnum,
  TirPmTooltipElement,
} from 'tir-components';
import { CrossCompactIcon } from 'tir-style-system/icons/outline';
import { computed } from 'vue';
import { CommentChatMessageModel } from './models';

/**
 * События
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'TirPmCommentChatQuoteMessage',
  props: {
    commentData: {},
    isDelitable: { type: Boolean },
    isClickable: { type: Boolean }
  },
  emits: ["deleteReply", "toReply"],
  setup(__props: any, { emit }) {

const props = __props;



/**Параметры компонента */


/**
 * Отправка события удаления комментария на который отвечают
 */
const onDeleteReply = () => {
  emit('deleteReply', computedCommentData.value);
};

/**
 * Отправка события для перемещения к комментарию
 */
const toReplyMessage = () => {
  if (props.isClickable) {
    emit('toReply', computedCommentData.value);
  }
};

/**
 * Данные
 */
const computedCommentData = computed(() => props.commentData);

const previewFile = computed<IFilePreview | undefined>(() => {
  if (props.commentData.File) {
    return {
      FileId: props.commentData.File.Id,
      Name: props.commentData.File.Name,
      Url: props.commentData.File.Url,
    };
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tir-pm-comment-chat-quote-message", {
      'tir-pm-comment-chat-quote-message--clickable': props.isClickable,
    }]),
    onClick: toReplyMessage
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(TirPmTooltipElement), null, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(computedCommentData.value.Author.FirstName) + " " + _toDisplayString(computedCommentData.value.Author.MiddleName) + " " + _toDisplayString(computedCommentData.value.Author.LastName), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(TirPmIconView), {
              size: 24,
              isRounded: "",
              colorCode: computedCommentData.value.Author.AvatarColor,
              imageLoadUrl: computedCommentData.value.Author.ImageUrl
            }, {
              mainSlot: _withCtx(() => [
                _createTextVNode(_toDisplayString(computedCommentData.value.Author?.FirstName[0].toUpperCase()) + _toDisplayString(computedCommentData.value.Author?.LastName[0].toUpperCase()), 1)
              ]),
              _: 1
            }, 8, ["colorCode", "imageLoadUrl"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString(computedCommentData.value.Message), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (previewFile.value)
        ? (_openBlock(), _createBlock(_unref(TirPmFilePreview), {
            key: 0,
            file: previewFile.value,
            variant: _unref(FilePreviewVariantEnum).Inline,
            "is-disabled-open": "",
            "hide-controls": ""
          }, null, 8, ["file", "variant"]))
        : _createCommentVNode("", true),
      (_ctx.isDelitable)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "tir-pm-comment-chat-quote-message__close-button",
            onClick: onDeleteReply,
            title: "Удалить ответ"
          }, [
            _createVNode(_unref(CrossCompactIcon))
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})